<template>
  <div>
    <!-- <CommonBreadCrumbSchemaComponent /> -->
    <div class="container my_custom_container_employer_three">
      <div class="row common_padding_top_section_employer_three">
        <div class="col-xl-12">
          <div class="benefit_div_three">
            <h2 class="common_futura_bold_font_employer_three common_employer_heading_three">
                Strategic Hiring Solutions
            </h2>
            <p class="common_employer_p_three">
              A next-generation recruitment ecosystem for discerning employers
            </p>
          </div>
        </div>
        <div class="col-xl-4 col-md-4 mobile_max_width_flex_three common_dsiplay_grid_em">
          <div class="benefits_box_three">
            <img
              :src="webUrl + 'assets/employerImages/Apply 1.png'"
              alt="Free trial"
            />
            <h3>Candidate Matching within minutes</h3>
            <p>
             Instantly connects with qualified applicants who meet your criteria, slashing time-to-hire from days to minutes
            </p>
          </div>
        </div>
        <div class="col-xl-4 col-md-4 mobile_max_width_flex_three common_dsiplay_grid_em">
          <div class="benefits_box_three">
            <img
              :src="webUrl + 'assets/employerImages/FT 1.png'"
              alt="Free full time job postings"
            />
            <h3>Risk-Free Trial for Full-Time Listings</h3>
            <p>
              Enjoy limited-time complimentary full-time job listings to experience our premium platform risk-free
            </p>
          </div>
        </div>
        <div class="col-xl-4 col-md-4 mobile_max_width_flex_three common_z_index common_dsiplay_grid_em">
          <div class="benefits_box_three">
            <!-- <img class="image1" :src="webUrl+'assets/employerImages/Ellipse-16.png'"> -->
            <img
              class=""
              :src="webUrl + 'assets/employerImages/Mail 1.png'"
              alt="Free CV downloads"
            />
            <!-- <img :src="webUrl+'assets/employerImages/Rectangle-567.png'"> -->
            <h3>Live Tracking & Alerts</h3>
            <p>Monitor applicants activity in real time with instant notifications for new applications and responses</p>
          </div>
        </div>
        <div class="col-xl-12">
            <div class="hiring_btn_three"> 
                <button
                id=""
                class="button"
                @click="getStartedEM()"
                >Start Hiring Today
            </button>
            </div>
        </div>
      </div>
    </div>
    <div class="container my_custom_container_employer_three">
      <div class="row common_padding_top_section_employer_three">
        <div class="col-7 col_md_7_employer_three col-md-7">
            <div class="text_section_em">
                <h2 class="common_futura_bold_font_employer_three common_employer_heading_three">We Get It, Finding The Right Hiring Software is Tough</h2>
                <p class="common_employer_p_three mt-4 mb-5">We understand that managing your hiring process effectively can be a major challenge. Our easy-to-use platform is designed to simplify this task and deliver immediate results.</p>
                <ul class="em_ul_three">
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Part-Time job marketplace</li>
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Free full-time job posting</li>
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Extensive database of jobseekers</li>
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Real-time application tracking</li>
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Fast applicant matching within minutes</li>
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Dedicated team to support</li>
                    <li><span><img :src="webUrl+'assets/employerImages/Vectors.png'"></span>Transparent and budget-friendly pricing</li>
                </ul>
                <!-- Desktop Badge Start -->
                <div class="our_badges_em common_desktop_two_tab_things_employer">
                    <img :src="webUrl+'assets/employerImages/Frame 2186.png'">
                    <img :src="webUrl+'assets/employerImages/Frame 2183.png'">
                    <img :src="webUrl+'assets/employerImages/Frame 2181.png'">
                </div>
                <div class="our_badges_em common_desktop_two_tab_things_employer our_badges_em_three">
                    <img :src="webUrl+'assets/employerImages/Frame 2185.png'">
                    <img :src="webUrl+'assets/employerImages/Frame 2184.png'">
                </div>
                 <!-- Desktop Badge End -->

                
            </div>
        </div> 
         <div class="col-5 col-md-5 col_md_5_employer_three">
            <div class="link_section_em">
            <img
              :src="webUrl + 'assets/employerImages/image 632.png'"
              alt="Free trial"
            />
            </div>
        </div> 
      </div>
    </div>
    <!-- Tab Badge Start -->
        <div class="container common_padding_top_section_employer_three my_custom_container_employer_three common_tab_two_desktop_things_employer">
            <div class="our_badges_em">
                <img :src="webUrl+'assets/employerImages/Frame 2186.png'">
                <img :src="webUrl+'assets/employerImages/Frame 2183.png'">
                <img :src="webUrl+'assets/employerImages/Frame 2181.png'">
            </div>
            <div class="our_badges_em">
                <img :src="webUrl+'assets/employerImages/Frame 2185.png'">
                <img :src="webUrl+'assets/employerImages/Frame 2184.png'">
            </div>
        </div>
    <!-- Tab Badge End -->
    <div class="container my_custom_container_employer_three">
      <div class="row common_padding_top_section_employer_three">
        <div class="col-xl-12">
            <h2 class="text-center common_futura_bold_font_employer_three common_employer_heading_three">Flexible Pricing Options </h2>
        </div>
        <div class="col-xl-4 col-md-4 mobile_col_md_three common_dsiplay_grid_em"
            @mouseenter="hoverIndex = 0"
            @mouseleave="hoverIndex = null">
            <div class="plans_div " :class="{ plans_div_linear_active: isActive(0) }">
                <h3>Essential Plan</h3>
                <p>Post & match your own candidates</p>
                <h4>features:</h4>
                <ul>
                    <li>Post jobs anytime via our platform</li>
                    <li>Freelancers apply directly to you</li>
                    <li>You review and select applicants</li>
                    <li>Prepaid Option: Pay upfront before posting</li>
                    <li>Ideal for one-time hiring</li>
                </ul>
            </div>
        </div>
         <div class="col-xl-4 col-md-4 mobile_col_md_three common_dsiplay_grid_em" 
            @mouseenter="hoverIndex = 1"
            @mouseleave="hoverIndex = null"
         >
            <div class="plans_div" :class="{ plans_div_linear_active: isActive(1) }">
                <h3 class="smart_text">Smart-Support Plan<span class="recommended_txt" :class="{ recommended_text_active: isActive(1) }">recommended</span></h3>
                <p>We help you find and filter candidates</p>
                <h4>features:</h4>
                <ul>
                    <li>We screen and match based on your job needs</li>
                    <li>Replace if someone drops out *</li>
                    <li>Fixed rate per person hired </li>
                    <li>Prepaid Option: Pay upfront before posting</li>
                    <li>Ideal for frequent or last-minute hiring</li>
                </ul>
                <button class="button">Choose Plan</button>
            </div>
        </div>
         <div class="col-xl-4 col-md-4 mobile_col_md_three common_dsiplay_grid_em"
            @mouseenter="hoverIndex = 2"
            @mouseleave="hoverIndex = null"
        >
             <div class="plans_div " :class="{ plans_div_linear_active: isActive(2) }">
                <h3>EA Manpower Plan</h3>
                <p>Full hiring service from start to finish</p>
                <h4>features:</h4>
                <ul>
                    <li>End-to-end hiring managed by our team</li>
                    <li>We handle all sourcing, filtering, and coordination</li>
                    <li>Includes schedule planning and follow-up</li>
                    <li>Postpaid option: pay after job is done</li>
                    <li>Ideal for companies with high-volume needs</li>
                </ul>
            </div>
        </div>
      </div>
    </div>
    <div class="common_padding_top_section_employer_three">
    </div>
  </div>
</template>

<script>
import { POST_API, GET_API, LOGIN, PERMISSION_DATA } from "../../../store/actions.type";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { Carousel, Slide } from "vue-carousel";
import VueSlickCarousel from "vue-slick-carousel";
import CommonBreadCrumbSchemaComponent from '../CommonSchemaComponent/CommonBreadCrumbSchemaComponent.vue';

export default {
  metaInfo: {
    title: "EL Connect – Job Posting Site in Singapore for Hiring",
    meta: [
      { charset: "utf-8" },
      { equiv: "content-type", content: "text/html" },
      {
        name: "description",
        content:
          "EL Connect is a job posting site in Singapore where employers can post full-time and part-time job ads. Enjoy our free job posting now!",
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "keywords",
        content:
          "el connect, job platform singapore, full time jobs, permanent part time, flexible job, daily paid jobs, temp staffing, temporary staffing jobs, part time daily paid jobs, daily paid jobs singapore, job posting site, part time jobs, daily paid, daily paid job, connect",
      },
      { property: "og:title", content: "EL Connect – Job Posting Site in Singapore for Hiring" },
      { property: "og:site_name", content: "EL Connect" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://elconnect.sg/employers" },
      {
        property: "og:image",
        content:
          "https://elconnect.sgp1.digitaloceanspaces.com/v2/general_setting/202281202127_general_setting.png",
      },
      {
        property: "og:description",
        content:
          "EL Connect is a job posting site in Singapore where employers can post full-time and part-time job ads. Enjoy our free job posting now!",
      },
      { name: "twitter:card", content: "summary" },
    ],
    link: [{ rel: "canonical", href: "https://elconnect.sg/employers" }],
  },

  data() {
    return {
      hoverIndex: null,
      defaultActiveIndex: 1, // second div is active by default
      items: null,
      testimonial: [],
      webUrl: process.env.VUE_APP_URL,
      error_message: "",
      job_items: [],
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        infinite: false,
        responsive: [
          {
            // breakpoint: 768,
            // settings: {
            // 	"slidesToShow": 1,
            // 		"slidesToScroll": 1,
            // 		"speed": 800,
            // 		"infinite": false,
            //         "dots":true,
            //         "arrows":false
            //     }
            breakpoint: 998,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              // "infinite": true,
              dots: true,
              arrow: true,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              // "infinite": true,
              dots: true,
              arrow: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              dots: true,
              arrow: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrow: true,
            },
          },
        ],
      },
      phone_number: "",
      company_name: "",
      success_message: "",
      totalFLCount: "24,000",
      email: "",
      password: "",
      fname1: "",
      comp_name1: "",
      lname1: "",
      semail1: "",
      mobile_number1: "",
      spassword1: "",
      srepassword1: "",
      user_type: "3",
      user_type_id: "",
      users_count: "",
    };
  },

  filters: {
  trimString: function(value) {
          if (!value) return ''
          return value.length > 35 ? value.substring(0, 32) + "..." : value;
      },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    dateTimeAgo: function (value) {
      if (!value) return "";
      const dateTimeAgo = moment(value).fromNow();
      return dateTimeAgo;
    },

    customizeRoleType: function (value) {
      if (!value) return "";
      var i,
        frags = value.split("-");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },

    removeUnderscore: function (value) {
      if (!value) return "";
      var i,
        frags = value.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
  },
  // filters: {
  //     trimString: function(value) {
  //         if (!value) return ''
  //         return value.length > 35 ? value.substring(0, 32) + "..." : value;
  //     }
  // },
  methods: {
    isActive(index) {
        return this.hoverIndex === index || (this.hoverIndex === null && index === this.defaultActiveIndex);
    },
    employerPasswordClick(event) {
      event.preventDefault();
      if ($("#show_hide_password_employer input").attr("type") == "text") {
        $("#show_hide_password_employer input").attr("type", "password");
        $("#show_hide_password_employer i").addClass("fa-eye-slash");
        $("#show_hide_password_employer i").removeClass("fa-eye");
      } else if ($("#show_hide_password_employer input").attr("type") == "password") {
        $("#show_hide_password_employer input").attr("type", "text");
        $("#show_hide_password_employer i").removeClass("fa-eye-slash");
        $("#show_hide_password_employer i").addClass("fa-eye");
      }
    },
    employerRepasswordClick(event) {
      event.preventDefault();
      if ($("#show_hide_repeat_password_employer input").attr("type") == "text") {
        $("#show_hide_repeat_password_employer input").attr("type", "password");
        $("#show_hide_repeat_password_employer i").addClass("fa-eye-slash");
        $("#show_hide_repeat_password_employer i").removeClass("fa-eye");
      } else if ($("#show_hide_repeat_password_employer input").attr("type") == "password") {
        $("#show_hide_repeat_password_employer input").attr("type", "text");
        $("#show_hide_repeat_password_employer i").removeClass("fa-eye-slash");
        $("#show_hide_repeat_password_employer i").addClass("fa-eye");
      }
    },
    getStartedEMMobile() {
      document
        .querySelector("#mobile_tab_max_width_flex12Mobile")
        .scrollIntoView({ behavior: "smooth", block: "center" });

      // document.querySelector("#mobile_tab_max_width_flex1").scrollIntoView({ behavior: "smooth", block: "center" });
    },
    getStartedEM() {
      document
        .querySelector("#mobile_tab_max_width_flex12")
        .scrollIntoView({ behavior: "smooth", block: "center" });

      // document.querySelector("#mobile_tab_max_width_flex1").scrollIntoView({ behavior: "smooth", block: "center" });
    },
    getMenuPermission() {
      this.$store
        .dispatch(PERMISSION_DATA, {
          data: {
            user_id: this.$store.getters.currentUser.id,
          },
          api: "/api/emp-menu-permissions",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
          } else {
            // console.log(this.$store.getters.getResults.data.full_name)
            this.menus = this.$store.getters.getResults.data;
            // JwtService.setMenuPermission(JSON.stringify(this.menus));
            // window.location.replace('/admin/dashboard');
            if (
              this.is_company_head == "no" &&
              (this.user_type_id == "3" || this.user_type_id == "4")
            ) {
              // if(this.account_verification_status == 'completed'){
              //     window.location.replace('/v2/employer/dp-job-manage');
              // }else if(this.ft_account_status == 'completed'){
              //     window.location.replace('/v2/employer/manage-jobs');
              // }else{
              //     window.location.replace('/v2/employer/om-supervisor-profile');
              // }
              // window.location.replace('/v2/employer/om-supervisor-profile');

              if (this.ft_account_status == "completed") {
                window.location.replace("/v2/employer/dashboard");
              } else {
                window.location.replace("/v2/employer/om-supervisor-profile");
              }
            } else if (this.user_type_id == "3" && this.is_company_head == "yes") {
              // this.getMenuPermission();
              // if(this.account_verification_status == 'completed'){
              //     window.location.replace('/v2/employer/dp-job-manage');
              // }else if(this.ft_account_status == 'completed'){
              //     window.location.replace('/v2/employer/manage-jobs');
              // }else{
              //     window.location.replace('/v2/employer/employer-profile');
              // }
              // window.location.replace('/v2/employer/employer-profile');
              if (this.ft_account_status == "completed") {
                window.location.replace("/v2/employer/dashboard");
              } else {
                window.location.replace("/v2/employer/employer-profile");
              }
            } else if (this.user_type_id == "5") {
              window.location.replace("/v2/jobseeker/jobseeker-profile");
            } else {
              window.location.replace("/v2/admin/dashboard");
            }
          }
        });
    },
    signup1() {
      console.log("fhfhfg");

      var err = false;
      $("#reg_button").hide();
      $("#loaderreg").show();

      $(".required-field1").each(function () {
        if ($(this).val() == "" || $(this).val().trim().length === 0) {
          err = true;
          $(this).addClass("error-jbs");
          // $(this).parent().parent().find('.required_content').addClass('show');
          // $(this).parent().parent().find('.error_x_white').addClass('show');
        } else {
          $(this).removeClass("error-jbs");
          // $(this).parent().parent().find('.required_content').removeClass('show');
          // $(this).parent().parent().find('.error_x_white').removeClass('show');
        }
      });
      $(".required-field-password").each(function () {
        if ($(this).val() == "" || $(this).val().trim().length === 0) {
          err = true;
          $(this).parent().addClass("error-jbs");
          // $(this).parent().parent().find('.required_content').addClass('show');
          // $(this).parent().parent().find('.error_x_white').addClass('show');
        } else {
          $(this).parent().removeClass("error-jbs");
          // $(this).parent().parent().find('.required_content').removeClass('show');
          // $(this).parent().parent().find('.error_x_white').removeClass('show');
        }
      });

      setTimeout(function () {
        $(".second_indiv_step_wrap .error-jbs").first().focus();

        $(".error-jbs").unbind("keypress");
        $(".error-jbs").bind("keypress", function () {
          $(this).removeClass("error-jbs");
          $(this).parent().parent().find(".error_x_white").removeClass("show");
        });
      }, 100);
      // if($('#checkbox:checked').val() != "true" && err == false){
      //     err = true;
      //     document.getElementById("errorIdSignup1").classList.add("show");
      //     document.getElementById("errorIdSignup1").textContent = 'Please accept terms and condition first.';
      // }
      if (err == false) {
        document.getElementById("errorIdSignup1").classList.remove("show");
        document.getElementById("errorIdSignup1").value = "";
        this.$store
          .dispatch(POST_API, {
            data: {
              //   first_name: 'Demo',
              //   last_name: 'Demo',
              first_name: this.fname1,
              last_name: this.lname1,
              comp_name: this.comp_name1,
              email: this.semail1,
              mobile_number: this.mobile_number1,
              password: this.spassword1,
              user_type: this.user_type,
              repassword: this.spassword1,
              register_from: "web",
              is_inquiry: "yes",
              popup: true,
              //   checkbox:$('#checkbox:checked').val() == 'true' ? true : false,
              checkbox: true,
            },
            api: "/api/signup",
          })
          .then(() => {
            $("#reg_button").show();
            $("#loaderreg").hide();
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              this.showDismissibleAlert = true;
              document.getElementById("errorIdSignup1").classList.add("show");
              document.getElementById("errorIdSignup1").textContent = this.error_message;
            } else {
              document.getElementById("errorIdSignup1").classList.remove("show");
              document.getElementById("errorIdSignup1").value = "";
              var userTypeId = {
                user_type_id: this.user_type,
              };
              localStorage.setItem("userTypeId", JSON.stringify(userTypeId));
              //   this.$swal({
              //                 position: 'center',
              //                 icon: 'success',
              //                 iconColor:'#4c8bf5',
              //                 title: 'Register successfully.',
              //                 showConfirmButton: false,
              //                 timer: 1500
              //     }).then(() => {
              this.slogin();

              //   this.$router.push({ name: 'login'});
              // })
              //   this.slogin();
            }
          });
      } else {
        $("#reg_button").show();
        $("#loaderreg").hide();
      }
    },
    slogin() {
      var err = false;
      $(".required-field1").each(function () {
        if ($(this).val() == "" || $(this).val().trim().length === 0) {
          err = true;
          $(this).addClass("error");
          $(this).parent().parent().find(".required_content").addClass("show");
          $(this).parent().parent().find(".error_x_white").addClass("show");
        } else {
          $(this).removeClass("error");
          $(this).parent().parent().find(".required_content").removeClass("show");
          $(this).parent().parent().find(".error_x_white").removeClass("show");
        }
      });

      setTimeout(function () {
        $(".second_indiv_step_wrap .error").first().focus();

        $(".error").unbind("keypress");
        $(".error").bind("keypress", function () {
          $(this).removeClass("error");
          $(this).parent().parent().find(".error_x_white").removeClass("show");
        });
      }, 100);
      if (err == false) {
        this.$store
          .dispatch(LOGIN, {
            data: {
              emailormobile: this.semail1,
              password: this.spassword1,
              user_type: this.user_type,
              role: "user",
              login_on: "web",
              popup: true,
            },
            api: "/api/login",
          })
          .then(() => {
            $("#reg_button").show();
            $("#loaderreg").hide();
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              document.getElementById("errorIdSignup").classList.add("show");
              document.getElementById("errorIdSignup").textContent = this.error_message;
            } else {
              // this.$bvModal.hide('bv-modal-example');
              this.$swal({
                position: "center",
                icon: "success",
                iconColor: "#4c8bf5",
                title: "Register successfully.",
                showConfirmButton: false,
                timer: 1500,
              }).then((result) => {
                // if(this.user_type == '3'){
                //     window.location.replace('/v2/employer/employer-profile');
                // }else{
                //     window.location.replace('/v2/jobseeker/jobseeker-profile');
                // }
                // this.is_company_head = this.$store.getters.currentUser.is_company_head;
                // if(this.is_company_head == 'no' && (this.user_type == '3' || this.user_type == '4')){
                //     window.location.replace('/v2/employer/om-supervisor-profile');
                // }else if(this.user_type == '3' && this.is_company_head == 'yes'){
                //     window.location.replace('/v2/employer/employer-profile');
                // }else if(this.user_type == '5'){
                //     window.location.replace('/v2/jobseeker/jobseeker-profile');
                // }else{
                //     window.location.replace('/v2/admin/dashboard');
                // }
                this.is_company_head = this.$store.getters.currentUser.is_company_head;
                this.user_type_id = this.$store.getters.currentUser.user_type_id;
                this.account_verification_status =
                  this.$store.getters.currentUser.account_verification_status;
                this.ft_account_status = this.$store.getters.currentUser.ft_account_status;
                this.getMenuPermission();
                // if(this.is_company_head == 'no' && (this.user_type_id == '3' || this.user_type_id == '4')){
                //     if(this.account_verification_status == 'completed'){
                //         window.location.replace('/v2/employer/dp-job-manage');
                //     }else if(this.ft_account_status == 'completed'){
                //         window.location.replace('/v2/employer/manage-jobs');
                //     }else{
                //         window.location.replace('/v2/employer/om-supervisor-profile');
                //     }
                //     // window.location.replace('/v2/employer/om-supervisor-profile');
                // }else if(this.user_type_id == '3' && this.is_company_head == 'yes'){
                //     if(this.account_verification_status == 'completed'){
                //         window.location.replace('/v2/employer/dp-job-manage');
                //     }else if(this.ft_account_status == 'completed'){
                //         window.location.replace('/v2/employer/manage-jobs');
                //     }else{
                //         window.location.replace('/v2/employer/employer-profile');
                //     }
                //     // window.location.replace('/v2/employer/employer-profile');
                // }else if(this.user_type_id == '5'){
                //     window.location.replace('/v2/jobseeker/jobseeker-profile');
                // }else{
                //     window.location.replace('/v2/admin/dashboard');
                // }
              });
            }
          });
      }
    },
    getWebsiteData() {
      return this.$store
        .dispatch(POST_API, {
          data: {
            keyword: this.filter,
          },
          api: "/api/website-data",
        })
        .then(() => {
          //window.scrollTo(0,0);
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            // this.showAlert();
            return [];
          } else {
            //this.role_types = this.$store.getters.getResults.data;
            this.banners = this.$store.getters.getResults.banners;
            this.job_categories = this.$store.getters.getResults.job_categories;
            this.process_descriptions = this.$store.getters.getResults.process_descriptions;
            this.items = this.$store.getters.getResults.partners;
            this.promotions = this.$store.getters.getResults.promotions;
            this.jobs_count = this.$store.getters.getResults.jobs;
            this.gigs = this.$store.getters.getResults.gigs;
            this.dp_jobs_count = this.$store.getters.getResults.dp_jobs_count;
            this.ft_jobs_count = this.$store.getters.getResults.ft_jobs_count;
            this.companies_count = this.$store.getters.getResults.companies_count;
            this.users_count = this.$store.getters.getResults.users_count;

            this.dailyjob_datas = this.$store.getters.getResults.dailyjob_datas;
            this.dailyjob_datas_count = this.$store.getters.getResults.dailyjob_datas_count;

            this.testimonial = this.$store.getters.getResults.testimonial_emp;

            // this.jobs.forEach(element => {
            // 	if(element.tag_names){
            // 		element.tag_names_val = element.tag_names.split(',');
            // 	}
            // });
            // this.generateSiteNavigationSchema();
          }
        });
    },
    openLink() {
      window.open("https://elconnectptuser.app.link/OSbf0HwLOib", "_blank");
    },
    showAlert() {
      // window.scrollTo(0,0);
      this.dismissCountDown = this.dismissSecs;

      this.$swal({
        position: "center",
        icon: "error",
        title: this.error_message,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    formSubmit(evt) {
      evt.preventDefault();
      this.$store
        .dispatch(POST_API, {
          data: {
            name: this.name,
            email: this.email,
            company_name: this.company_name,
            phone_number: "+65 " + this.phone_number,
          },
          api: "/api/get-in-touch-employer",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
          } else {
            this.success_message = this.$store.getters.getResults.message;

            this.$swal({
              position: "center",
              icon: "success",
              iconColor: "#4c8bf5",
              title: this.success_message,
              showConfirmButton: false,
              timer: 1500,
            });
            (this.name = ""), (this.email = ""), (this.phone_number = ""), (this.company_name = "");
          }
        });
    },
  },
  mounted() {
    // $('.count').each(function () {
    //     $(this).text(0);
    // });

    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };

    window.scrollTo(0, 0);
    //  this.getWebsiteData();
    this.getWebsiteData().then(() => {
      async function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
      }
      $(window).scroll(async function () {
        var element = document.getElementById("company-count");
        var value = element.textContent;
        //    console.log(value);
        $(".count").each(async function () {
          if ((await isScrolledIntoView(this)) === true) {
            $(this)
              .prop("Counter", 0)
              .animate(
                {
                  Counter: $(this).data("count"),
                },
                {
                  duration: 3000,
                  easing: "swing",
                  step: function (now) {
                    $(this).text(Math.ceil(now).toLocaleString("en-IN"));
                  },
                }
              );
          }
        });
      });
    });
    $("#slideshow > div:gt(0)").hide();

    // Function for changing to the next slide
    let nextSlide = (count, delay) => {
      // Set the delay on the slide
      setTimeout(() => {
        // Hide the current slide
        $("#slideshow > div:nth-of-type(" + count + ")")
          .hide()
          .removeClass("slide_dynamic_class");
        // If we've reached the end of the slides, set count back to 1,
        // otherwise, increment by 1
        count !== $("#slideshow > div").length ? count++ : (count = 1);
        // Show the next slide
        $("#slideshow > div:nth-of-type(" + count + ")")
          .show()
          .addClass("slide_dynamic_class");
        $(".slide_dynamic_class").css({ position: "relative", opacity: 0, left: "+=10000" });
        $(".slide_dynamic_class").animate({ left: 0, opacity: 1 });
        // Set the delay to the value of the data-delay attribute on the
        // slide elements
        delay = $("#slideshow > div:nth-of-type(" + count + ")").data("delay");
        // Call this function recursively
        nextSlide(count, delay);
      }, delay);
    };

    nextSlide(1, $("#slideshow > div:first").data("delay"));

    //Mobile Slide Start

    $("#slideshow-mobile > div:gt(0)").hide();

    // Function for changing to the next slide
    let nextSlideMobile = (count, delay) => {
      // Set the delay on the slide
      setTimeout(() => {
        // Hide the current slide
        $("#slideshow-mobile > div:nth-of-type(" + count + ")")
          .hide()
          .removeClass("slide_dynamic_class");
        // If we've reached the end of the slides, set count back to 1,
        // otherwise, increment by 1
        count !== $("#slideshow-mobile > div").length ? count++ : (count = 1);
        // Show the next slide
        $("#slideshow-mobile > div:nth-of-type(" + count + ")")
          .show()
          .addClass("slide_dynamic_class");
        $(".slide_dynamic_class").css({ position: "relative", opacity: 0, left: "+=10000" });
        $(".slide_dynamic_class").animate({ left: 0, opacity: 1 });
        // Set the delay to the value of the data-delay attribute on the
        // slide elements
        delay = $("#slideshow-mobile > div:nth-of-type(" + count + ")").data("delay");
        // Call this function recursively
        nextSlideMobile(count, delay);
      }, delay);
    };

    nextSlideMobile(1, $("#slideshow-mobile > div:first").data("delay"));

    //Mobile Slider End
  },

  components: {
    VueSlickCarousel,
    Carousel,
    Slide,
    CommonBreadCrumbSchemaComponent
  },
};
</script>